import CheckmarkIcon from '@/svgs/Checkmark'
import RightArrowIcon from '@/svgs/RightArrow'
import Link from 'next/link'
import React from 'react'

const PortfolioItem = ({
   imageSrc,
   title,
   description,
   businessNeeds,
   learnMoreLink,
   imageFirst = true,
}) => {
   const content = (
      <>
         {imageFirst === true ? (
            <div className="portimage-image-section">
               <img src={imageSrc} alt={title} />
            </div>
         ) : null}
         <div className="portfolio-content-section section_theme_2_bg text-start">
            <div className="mx-3">
               <h2>{title}</h2>
               <p>{description}</p>
               <h4 className='business-need-title'>Business Needs:</h4>
               <ul className="checklist">
                  {businessNeeds.map((need, index) => (
                     <li key={index}>
                        <CheckmarkIcon />
                        {need}
                     </li>
                  ))}
               </ul>
               <Link className="btn learn-more mt-5" href={learnMoreLink}>
                  {/* <a className="btn learn-more mt-5"> */}
                  LEARN MORE
                  <RightArrowIcon />
                  {/* </a> */}
               </Link>
            </div>
         </div>
         {imageFirst === false ? (
            <div className="portimage-image-section">
               <img src={imageSrc} alt={title} />
            </div>
         ) : null}
      </>
   )

   return (
      <div className="d-flex justify-content-center">
         <div className="portfolio-story-content section_secondary_bg">
            {content}
         </div>
      </div>
   )
}

export default PortfolioItem
